import 'whatwg-fetch'; // load fetch polyfill

import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import createHistory from 'history/createBrowserHistory';
import { Route } from 'react-router';

import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux';

import './styles/app.css';
import reducers from "./reducers/reducers";
import ApartmentLandingPage from "./pages/landing-page/ApartmentLandingPage";
import ApartmentSelectPage from "./pages/apartment-select/ApartmentSelectPage";
import ViewApartmentPage from "./pages/view-apartment/ViewApartmentPage";
import loadDataThunk from "./thunks/loadDataThunk";

const history = createHistory();
const middleware = routerMiddleware(history);

/*eslint-disable no-undef*/
// add a history push listener
history.listen(location => {
    // ensure ispLog is defined
    if (typeof(ispLog) === "function") {
        let data = {
            href: location.pathname,
            text: ''
        };

        ispLog('click', data);
    }
});
/*eslint-enable no-undef*/

// load in loading spinner
let spinnerDiv = document.createElement('div');
spinnerDiv.classList.add('loader');
document.getElementById('root').appendChild(spinnerDiv);

// create a store using our custom reducer and the route reducer
const store = createStore(
    combineReducers({
        ...reducers,
        router: routerReducer
    }),
    applyMiddleware(thunk, middleware)
);

// trigger the load remote data thunk
store.dispatch(loadDataThunk()).then(function () {
    // don't render until we have loaded our data endpoint
    // set up the context to include redux and router
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <div className="ispi-core">
                    <Route exact path="/apartments" component={ApartmentLandingPage} />
                    <Route exact path="/apartments/level/:aptLevel" component={ApartmentSelectPage} />
                    <Route exact path="/apartments/level/:aptLevel/apartment/:number" component={ViewApartmentPage} />
                </div>
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root')
    );
});


// WEBPACK FOOTER //
// ./src/index.js